import { render, staticRenderFns } from "./MyGifts.vue?vue&type=template&id=0ee08fdc&scoped=true"
import script from "./MyGifts.vue?vue&type=script&lang=js"
export * from "./MyGifts.vue?vue&type=script&lang=js"
import style0 from "./MyGifts.vue?vue&type=style&index=0&id=0ee08fdc&prod&lang=scss&scoped=true"
import style1 from "./MyGifts.vue?vue&type=style&index=1&id=0ee08fdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee08fdc",
  null
  
)

export default component.exports